<div class="container">
  <div class="col-lg-1 col-xs-1">
    <div class="row col-lg-8 col-xs-12"> 
      <div  *ngFor="let card of cardsouce$ | async">
        <!-- <div class="col-lg-5 col-xs-9">  -->
          <span [ngSwitch]="card.source.brand">
              <i *ngSwitchCase="'American Express'" class="fa fa-cc-amex"></i>
              <i *ngSwitchCase="'Discover'" class="fa fa-cc-discover"></i>
              <i *ngSwitchCase="'JCB'" class="fa fa-cc-jcb"></i>
              <i *ngSwitchCase="'Visa'" class="fa fa-cc-visa"></i>
              <i *ngSwitchCase="'Diners Club'" class="fa fa-cc-diners-club"></i>
              <i *ngSwitchCase="'MasterCard'" class="fa fa-cc-mastercard"></i>
              <i *ngSwitchDefault class="fa fa-credit-card"></i>
          </span>
          <label class="card-info align-baseline"> <sup>**** **** ****</sup> {{card.source.last4}} {{card.source.exp_month}}/{{card.source.exp_year}} </label>
        <!-- </div>
        <div class="col-lg-2 col-xs-2">  -->
          <i class="fa fa-pencil card-action" aria-hidden="true" (click)="updateCard(card.source.id, card.source.fingerprint)"> Edit </i>
          <i class="fa fa-trash card-action" aria-hidden="true" (click)="deleteCard(card.source.id, card.source.fingerprint)"> Delete </i>
        <!-- </div>   -->
      </div>
    </div>
    <div class="col-lg-8 col-xs-12"> 
      <div class="row col-lg-5 col-xs-9">
          <i class="fa fa-plus-square-o card-action" aria-hidden="true">Add Card</i>
      </div>
    </div>
  </div>
</div>